import { motion } from "framer-motion";
import { Map, ShieldCheck, Zap, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSiteData } from "../../context/SiteData";

const ICONS = [Map, ShieldCheck, Zap, MapPin];

export const WhyChoose = () => {
  const { content } = useSiteData();
  const items = content.why_items && content.why_items.length ? content.why_items : [];
  return (
  <section id="features" className="relative py-24 sm:py-32" data-testid="why-choose-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-[var(--brand)]" data-testid="why-choose-eyebrow">
          {content.why_eyebrow}
        </p>
        <h2 className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0b132b]" data-testid="why-choose-title">
          {content.why_title}
        </h2>
        <div className="mt-6 h-1 w-20 rounded-full bg-[var(--brand)]" />
      </Reveal>

      <div className="mt-16 grid md:grid-cols-2 gap-6 lg:gap-8">
        {items.map((c, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
          <Reveal key={i} delay={i * 0.1} className={i % 2 === 1 ? "md:mt-14" : ""}>
            <motion.div
              data-testid={`why-choose-card-${i}`}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className="group relative h-full rounded-3xl bg-white border border-slate-100 p-8 sm:p-10 shadow-[0_16px_40px_-20px_rgba(11,19,43,0.15)] hover:shadow-[0_30px_60px_-24px_rgba(225,29,72,0.35)] hover:border-[var(--brand)]/30 transition-colors duration-300"
            >
              <span className="absolute top-7 right-8 font-display font-extrabold text-5xl text-slate-100 group-hover:text-[var(--brand)]/15 transition-colors duration-300 select-none">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="w-14 h-14 rounded-2xl bg-[var(--brand-soft)] flex items-center justify-center transition-colors duration-300 group-hover:bg-[var(--brand)]">
                <Icon className="w-7 h-7 text-[var(--brand)] transition-colors duration-300 group-hover:text-white" strokeWidth={2} />
              </span>
              <h3 className="mt-6 font-display font-bold text-xl sm:text-2xl text-[#0b132b]">
                {c.title}
              </h3>
              <p className="mt-3 text-base text-slate-600 leading-relaxed">{c.copy}</p>
            </motion.div>
          </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
